import { formatCurrency, getCurrencySymbol } from "@angular/common";
import { Inject, Injectable, LOCALE_ID } from "@angular/core";
import { isNil, toNumber } from "lodash-es";

import { CurrencyConfigService } from "./currency.config";
import { CurrencyDisplay, CurrencyDisplayType } from "./currency.model";

@Injectable({
	providedIn: "root",
})
export class CurrencyService {
	constructor(
		@Inject(LOCALE_ID) private locale: string,
		private config: CurrencyConfigService
	) {}

	format(
		value: string | number | null | undefined,
		display: CurrencyDisplay | string | CurrencyDisplayType = CurrencyDisplay.SymbolNarrow,
		currencyCode?: string,
		digitsInfo = "1.2-2",
		hideValue?: boolean,
		onlySymbol?: boolean
	): string | null {
		if (isNil(value)) {
			return null;
		}

		const currency = this.getCurrency(currencyCode, display);

		if (onlySymbol) {
			return currency;
		}

		if (hideValue) {
			return `${currency} ${"\u2022".repeat(5)}`;
		}

		return formatCurrency(toNumber(value), this.locale, currency, currencyCode, digitsInfo);
	}

	private getCurrency(
		currencyCode?: string,
		display: CurrencyDisplay | string | CurrencyDisplayType = CurrencyDisplay.SymbolNarrow
	): string {
		if (display === "") {
			return "";
		}

		currencyCode = currencyCode || this.config.get()?.currencyCode || "";

		if (display === CurrencyDisplay.Code) {
			return currencyCode;
		}
		return getCurrencySymbol(currencyCode, display === CurrencyDisplay.Symbol ? "wide" : "narrow", this.locale);
	}
}
